import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BRAND from '../../config/brand';
import { Input, Badge, Avatar, Dropdown, Button } from 'antd';
import {
  SearchOutlined,
  BellOutlined,
  UserOutlined,
  DownOutlined,
  MenuOutlined,
  LogoutOutlined,
  SettingOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './TopBar.css';

const TopBar = ({ onMenuToggle, collapsed }) => {
  const { user, logout, isAuthenticated, loading } = useAuth();
  const [localUser, setLocalUser] = useState(null);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');

  // 从 localStorage 恢复用户状态
  useEffect(() => {
    const saved = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (saved && token) {
      try {
        setLocalUser(JSON.parse(saved));
      } catch (e) {
        setLocalUser(null);
      }
    }
  }, [user, isAuthenticated]);

  const effectiveUser = user || localUser;
  const isLoggedIn = !!effectiveUser;

  const handleSearch = (value) => {
    if (value.trim()) {
      navigate(`/skills?search=${encodeURIComponent(value)}`);
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '设置',
      onClick: () => navigate('/settings'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: logout,
    },
  ];

  return (
    <header className="topbar">
      <div className="topbar-left">
        <Button
          type="text"
          className="menu-toggle"
          onClick={onMenuToggle}
          icon={<MenuOutlined />}
        />
        <Link to="/" className="topbar-logo">
          <span className="logo-icon">🎵</span>
          <span className="logo-text">{BRAND.name}</span>
        </Link>
      </div>

      <div className="topbar-center">
        <Input.Search
          className="search-box"
          placeholder="搜索技能..."
          prefix={<SearchOutlined />}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onSearch={handleSearch}
          enterButton
          size="large"
        />
      </div>

      <div className="topbar-right">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/publish')}
          className="publish-btn"
          style={{ marginRight: 16 }}
        >
          发布 Skill
        </Button>
        
        <Badge count={0} className="notification-badge">
          <Button
            type="text"
            icon={<BellOutlined />}
            className="icon-btn"
          />
        </Badge>

        {isLoggedIn ? (
          <Dropdown
            menu={{ items: userMenuItems }}
            placement="bottomRight"
            arrow
          >
            <div className="user-info">
              <Avatar
                src={effectiveUser?.avatar}
                icon={!effectiveUser?.avatar && <UserOutlined />}
                className="user-avatar"
              />
              <span className="user-name">{effectiveUser?.name || '用户'}</span>
              <DownOutlined className="user-arrow" />
            </div>
          </Dropdown>
        ) : (
          <div className="auth-buttons">
            <Button type="text" onClick={() => navigate('/login')}>
              登录
            </Button>
            <Button type="primary" onClick={() => navigate('/register')}>
              注册
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopBar;
